import API from "../../../app/api";

export const getSaleOnTheTable = async () => {
  try {
    const res = await API.get("/banners/section/SALE_ON_THE_TABLE");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch promo banners");
    }
    return res.data?.data?.banners || [];
  } catch (error) {
    console.error("getSaleOnTheTable error:", error);
    return [];
  }
};